declare global {
  interface Window {
    pbjs: any;
    googletag?: any;
  }

  const pbjs: any;
}

const INTENT_IQ_PARTNER_ID = 858577937;

export const initPrebid = () => {
  if (!window.pbjs || !window.pbjs.que) {
    console.error("Prebid not ready. Make sure prebid.js is loaded before calling initPrebid.");
    return false;
  }

  window.pbjs.que.push(() => {
    window.pbjs.setConfig({
      debug: true,
      userSync: {
        userIds: [
          {
            name: "intentIqId",
            params: {
              partner: INTENT_IQ_PARTNER_ID,
              timeoutInMillis: 500,
              callback: (data: any) => {
                console.log('IntentIQ ID received:', data);
              },
              groupChanged: (group: string) => {
                console.log('IntentIQ group changed:', group);
              },
              domainName: window.location.hostname,
              gamObjectReference: window.googletag,
              gamParameterName: "intent_iq_group",
              abPercentage: 95,
              ABTestingConfigurationSource: "IIQServer",
              chTimeout: 10
            },
            storage: {
              type: "html5",
              name: "intentIqId",
              expires: 90,
              refreshInSeconds: 8 * 3600
            }
          }
        ],
        syncDelay: 3000,
        auctionDelay: 500
      },
      consentManagement: {
        gdpr: {
          cmpApi: 'iab',
          timeout: 8000,
          allowAuctionWithoutConsent: false
        },
        usp: {
          cmpApi: 'iab',
          timeout: 100
        },
        gpp: {
          cmpApi: 'iab',
          timeout: 8000
        }
      }
    });

    window.pbjs.enableAnalytics({
      provider: 'iiqAnalytics',
      options: {
        partner: INTENT_IQ_PARTNER_ID,
        domainName: window.location.hostname,
        ABTestingConfigurationSource: 'IIQServer',
        manualWinReportEnabled: false,
        gamPredictReporting: false,
        gamObjectReference: window.googletag,
        abPercentage: 95
      }
    });

    console.log("Prebid fully initialized with IntentIQ modules");
  });

  return true;
};

